var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 201,
    viewBox: "0 0 201 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 100.5C0.5 45.2715 45.2715 0.5 100.5 0.5C155.728 0.5 200.5 45.2715 200.5 100.5C200.5 155.728 155.728 200.5 100.5 200.5H0.5V100.5Z",
    fill: "#E7E9EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.156 29.3438L156.031 51.8438C162.219 54.6562 167 60.5625 167 67.875C166.719 96 155.188 146.906 106.812 170.25C102.031 172.5 96.6875 172.5 91.9062 170.25C43.5312 146.906 32 96 32 67.875C31.7188 60.5625 36.5 54.6562 42.6875 51.8438L95.5625 29.3438C96.6875 28.7812 98.0938 28.5 99.5 28.5C100.625 28.5 102.031 28.7812 103.156 29.3438ZM115.25 87C115.25 78.5625 107.938 71.25 99.5 71.25C90.7812 71.25 83.75 78.5625 83.75 87C83.75 93.4688 87.4062 98.8125 92.75 101.344V120.75C92.75 124.688 95.5625 127.5 99.5 127.5C103.156 127.5 106.25 124.688 106.25 120.75V101.344C111.312 98.8125 115.25 93.4688 115.25 87Z",
    fill: "#74C5FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.25 101.344V120.75C106.25 124.688 103.156 127.5 99.5 127.5C95.5625 127.5 92.75 124.688 92.75 120.75V101.344C87.4062 98.8125 83.75 93.4688 83.75 87C83.75 78.5625 90.7812 71.25 99.5 71.25C107.938 71.25 115.25 78.5625 115.25 87C115.25 93.4688 111.312 98.8125 106.25 101.344Z",
    fill: "#0061A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.b4b2f1dbaab544f72cbb1f35dac088c0.svg";
export { ForwardRef as ReactComponent };